import React from 'react';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n-lite';
import { bindActionCreators } from 'redux';
import * as _ from 'lodash';

import CustomReveal from '../../../common/reveal/CustomReveal';
import HeaderReveal from '../../../common/reveal/HeaderReveal';

import * as bookActions from '../../../../actions/bookActions';
import * as contentActions from '../../../../actions/contentActions';
import * as customTranslate from '../../../../services/translate/customTranslateService';
import { SmartButton } from '../../../common/SmartButton';
import PropTypes from 'prop-types';

class ReDownloadBookReveal extends React.Component {
  static propTypes = {
    bookToReDownload: PropTypes.object,
    classroom: PropTypes.object,
    language: PropTypes.string,
    contentActions: PropTypes.object,
    bookActions: PropTypes.object
  };

  closeModal() {
    const { bookActions } = this.props;
    bookActions.setReDownloadBookState(null);
  }

  handleSaveBook() {
    const { bookToReDownload, contentActions, classroom, language } = this.props;
    const classroomId = classroom ? classroom.id : '';
    let title = '';

    if (!_.isEmpty(bookToReDownload)) {
      title = this.getBookName(bookToReDownload, language);
    }
    this.closeModal();
    contentActions.reDownloadBook(classroomId, bookToReDownload, title);
  }

  renderContent(title) {
    return (
      <div className="content">
        <div className="text">{I18n.t('common.reDownloadConfirmation', { title })}</div>
      </div>
    );
  }

  renderFooterButtons() {
    return (
      <div className="footer">
        <div className="footer-content">
          <SmartButton id="cancel-button" onClick={this.closeModal.bind(this)}>
            {I18n.t('common.cancel')}
          </SmartButton>
          <SmartButton danger id="confirm-button" onClick={this.handleSaveBook.bind(this)}>
            {I18n.t('common.option.download')}
          </SmartButton>
        </div>
      </div>
    );
  }

  getBookName(bookToReDownload, language) {
    let bookName = bookToReDownload.name;

    if (!(typeof bookName === 'object')) {
      bookName = JSON.parse(bookName);
    }

    return customTranslate.translateObject(bookName, language);
  }

  render() {
    const { bookToReDownload, language } = this.props;
    let active = false;
    let title = '';

    if (!_.isEmpty(bookToReDownload)) {
      title = this.getBookName(bookToReDownload, language);
      active = true;
    }

    return (
      <CustomReveal id="re-download-book" active={active} close={this.closeModal.bind(this)}>
        <div className="parent">
          <HeaderReveal title={I18n.t('common.uSure')} onCloseOnClick={this.closeModal.bind(this)} />
          {this.renderContent(title)}
          {this.renderFooterButtons()}
        </div>
      </CustomReveal>
    );
  }
}

function mapStateToProps(state) {
  return {
    bookToReDownload: state.book.bookToReDownload,
    i18n: state.i18n,
    colors: state.theme.colors,
    classroom: state.classrooms.selectedClassroom.classroom,
    language: state.account.user.language
  };
}

function mapDispatchToProps(dispatch) {
  return {
    bookActions: bindActionCreators(bookActions, dispatch),
    contentActions: bindActionCreators(contentActions, dispatch),
    dispatch
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ReDownloadBookReveal);
